import { useNavigate } from "react-router-dom";
// import { functions } from "../../../appwrite/appwriteConfig";
import { useAuth } from "../../../utils/AuthContext";
import { useState } from "react";

const plansTypes = {
    FREE: "FREE",
    MASTER_MONTHLY: "MASTER_MONTHLY",
    MASTER_YEARLY: "MASTER_YEARLY",
    CLUB_LICENCE: "CLUB_LICENCE",
};

function Plan({ plan, billingPeriod }) {
    const navigate = useNavigate();
    const { user, license } = useAuth();
    // eslint-disable-next-line
    const [isLoading, setIsLoading] = useState(false);

    const handlePurchase = async (selectedPlan) => {
        if (!user) {
            navigate("/login");
            return;
        } else if (user && !user.prefs?.chesscom) {
            navigate("/setup");
            return;
        }

        //Make sure that the user doesn't already have a paid account first check on client side.
        if (
            license === "masterMonthly" &&
            selectedPlan.plan === plansTypes.MASTER_MONTHLY
        ) {
            window.open(
                "https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne",
                "_blank",
                "noopener,noreferrer"
            );
            return;
        }

        if (
            license === "masterYearly" &&
            selectedPlan.plan === plansTypes.MASTER_YEARLY
        ) {
            window.open(
                "https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne",
                "_blank",
                "noopener,noreferrer"
            );
            return;
        }

        if (selectedPlan.plan === plansTypes.FREE) {
            window.open(
                "https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne",
                "_blank",
                "noopener,noreferrer"
            );

            // navigate("/download");
            return;
        }

        window.open(
            "https://discord.gg/XGCgEBkbjn",
            "_blank",
            "noopener,noreferrer"
        );

        // Uncomment the following lines if you want to handle the purchase

        // setIsLoading(true);

        // try {
        //     const executionPlan =
        //         selectedPlan.plan === plansTypes.MASTER_MONTHLY
        //             ? "masterMonthly"
        //             : "masterYearly";

        //     const response = await functions.createExecution(
        //         "686cd8530014febec91b",
        //         JSON.stringify({
        //             plan: executionPlan,
        //         }),
        //         false,
        //         "/payments",
        //         "POST"
        //     );

        //     window.location.href = JSON.parse(
        //         response.responseBody
        //     ).checkout_url;
        // } finally {
        //     setIsLoading(false);
        // }
    };

    return (
        <article className="plan">
            <header className="plan-upper-text-wrapper">
                <h3 className="plan-title">{plan.title}</h3>
                <p className="plan-description">{plan.description}</p>
            </header>
            <div className="plan-lower-price-cta">
                <div className="separator" />
                <div className="plan-price-wrapper">
                    {/* <span className="plan-price-post">$0</span>{" "} */}
                    <span className="plan-price">
                        {plan.price.includes("Custom")
                            ? "Custom"
                            : plan.price.includes("Free")
                            ? "Free"
                            : "$" + plan.price}
                    </span>
                    {plan.price.includes("Custom") ||
                    plan.price.includes("Free") ? (
                        ""
                    ) : (
                        <span className="lifetime">
                            {billingPeriod === "monthly" ? "/month" : "/year"}
                        </span>
                    )}
                </div>
                {plan.isCustom === true ? (
                    <button
                        className="plan-cta"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePurchase(plan);
                        }}
                        type="button"
                    >
                        <span className="plan-cta-text">Try now</span>
                    </button>
                ) : plan.price.includes("Custom") ? (
                    <button
                        className="plan-cta"
                        onClick={(e) => {
                            e.preventDefault();
                            window.open("mailto:contact@oakmate.app", "_blank");
                        }}
                        type="button"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: "block" }}
                            >
                                <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="black"
                                    strokeWidth="1"
                                    fill="none"
                                    opacity="0.25"
                                />
                                <path
                                    d="M22 12a10 10 0 0 1-10 10"
                                    stroke="black"
                                    strokeWidth="1"
                                    fill="none"
                                >
                                    <animateTransform
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 12 12"
                                        to="360 12 12"
                                        dur="0.8s"
                                        repeatCount="indefinite"
                                    />
                                </path>
                            </svg>
                        ) : (
                            <span className="plan-cta-text">Talk to sales</span>
                        )}
                    </button>
                ) : (
                    <button
                        className="plan-cta"
                        onClick={(e) => {
                            e.preventDefault();
                            if (!isLoading) {
                                handlePurchase(plan);
                            }
                        }}
                        type="button"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: "block" }}
                            >
                                <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="black"
                                    strokeWidth="1"
                                    fill="none"
                                    opacity="0.25"
                                />
                                <path
                                    d="M22 12a10 10 0 0 1-10 10"
                                    stroke="black"
                                    strokeWidth="1"
                                    fill="none"
                                >
                                    <animateTransform
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 12 12"
                                        to="360 12 12"
                                        dur="0.8s"
                                        repeatCount="indefinite"
                                    />
                                </path>
                            </svg>
                        ) : (
                            // <span className="plan-cta-text">Subscribe</span>
                            <span className="plan-cta-text">
                                Join waiting List
                            </span>
                        )}
                    </button>
                )}
            </div>
        </article>
    );
}

function PricingSection() {
    const [billingPeriod, setBillingPeriod] = useState("monthly"); // 'monthly' or 'yearly'

    const plans = [
        {
            title: "Beginner",
            description:
                "Unlimited access to all core features, including full game review, move classification, and training tools. No card required.",
            price: "Free",
            isCustom: true,
            plan: plansTypes.FREE,
        },
        {
            title: "Master",
            description:
                "(Comming Soon) Unlock AI-powered coaching, instant cloud analysis, custom puzzles, and detailed progression insights. Cancel anytime.",
            price: billingPeriod === "monthly" ? "5" : "30",
            isCustom: false,
            plan:
                billingPeriod === "monthly"
                    ? plansTypes.MASTER_MONTHLY
                    : plansTypes.MASTER_YEARLY,
        },
        {
            title: "Club Plan",
            description:
                "Custom pricing for teams, schools, or chess clubs. Includes Pro features for all members under one license.",
            price: "Custom",
            isCustom: false,
            plan: plansTypes.CLUB_LICENCE,
        },
    ];

    return (
        <>
            <header className="section-title-container">
                <h2 className="section-title">
                    Play Smarter. Upgrade Anytime.
                </h2>
                <p className="section-subtitle">
                    From blitz to tournaments, Oakmate is free to start.
                </p>
            </header>
            <div className="pricing-section-wrapper">
                {/* SWITCH COMPONENT */}
                <div className="billing-toggle">
                    <span
                        className={
                            billingPeriod === "monthly" ? "active-period" : ""
                        }
                    >
                        Monthly
                    </span>
                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={billingPeriod === "yearly"}
                            onChange={() =>
                                setBillingPeriod((prev) =>
                                    prev === "monthly" ? "yearly" : "monthly"
                                )
                            }
                        />
                        <span className="slider"></span>
                    </label>
                    <span
                        className={
                            billingPeriod === "yearly" ? "active-period" : ""
                        }
                    >
                        Yearly
                    </span>
                </div>
                {/* END SWITCH */}
                <div className="plans-wrapper">
                    {plans.map((plan, index) => (
                        <Plan
                            key={index}
                            plan={plan}
                            billingPeriod={billingPeriod}
                        />
                    ))}
                </div>
            </div>
            <p className="guarantee">
                Test Oakmate completely free—no card required, no limits on your
                core features.
            </p>
        </>
    );
}

export default PricingSection;
